import ApiService from "@/common/api.service"

export const RoleService = {
    create(params) {
        return ApiService.post("roles/add", params);
    },
    update(slug, params) {
        return ApiService.update("/roles", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("roles/delete", slug, params)
    },
    async getRoles() {
        const res = await ApiService.get("/roles");
        return res.data;
    },
    async getRolesWP(page, itemsPerPage, name) {
        const res = await ApiService.get(
            `/roles?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
        return res.data;
    },
    async getRolesByGroupId(groupId) {
        const res = await ApiService.get("/groups/roles/" + `${groupId}`);
        return res.data;

    }

}